const PAYMENT_SUCCESS = {
  screenDataAid: "paymentSuccessful",
  iconDataAid: "top",
  headerData: {
    dataAid: "orderCancelRequest",
  },
  title: {
    text: "Payment successful",
    dataAid: "title",
  },
  setUpEasySip: {
    text: "Setup easysip",
    dataAid: "primary",
  },
  cta: {
    text: "go to orders",
    dataAid: "primary",
  },
  viewOrders: {
    text: "View my orders",
    dataAid: "myOrders",
  },
};

export default PAYMENT_SUCCESS;
